import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import y from 'y4/Utils';
import classNames from 'classnames';

const BasicList = ({ form, panel, data, index }) => {
  if (form);
  const templete = y.gpv(panel, 'option.html');
  const html = y.formatByNamedArgs(templete, data);

  return (
    <>
      <Col
        xs={12}
        className={classNames('p-x1', {
          'bg-100': index % 2 !== 0
        })}
      >
        <Row>
          <div
            dangerouslySetInnerHTML={{
              __html: html
            }}
          ></div>
        </Row>
      </Col>
    </>
  );
};

BasicList.propTypes = {
  form: PropTypes.object,
  panel: PropTypes.object,
  data: PropTypes.object,
  index: PropTypes.number
};

export default BasicList;
